const FreebieesSVG = ({ stroke, fill }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 32 32"
      fill='none'
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <path
          id="Vector"
          d="M4.26758 17.4668H27.7342V27.7335C27.7342 29.3535 26.421 30.6668 24.8009 30.6668H7.20091C5.58088 30.6668 4.26758 29.3535 4.26758 27.7335V17.4668Z"
          stroke={stroke}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M1.33398 11.5996H30.6673V17.4663H1.33398V11.5996Z"
          stroke={stroke}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_3"
          d="M16 5.7334V30.6667"
          stroke={stroke}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_4"
          d="M16.001 6.46634C16.001 3.63127 13.7028 1.33301 10.8677 1.33301C8.03264 1.33301 5.73438 3.63127 5.73438 6.46634C5.73438 9.30141 8.03264 11.5997 10.8677 11.5997"
          stroke={stroke}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_5"
          d="M21.1333 11.5997C23.9684 11.5997 26.2667 9.30141 26.2667 6.46634C26.2667 3.63127 23.9684 1.33301 21.1333 1.33301C18.2983 1.33301 16 3.63127 16 6.46634"
          stroke={stroke}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export default FreebieesSVG;
